export interface Account {
  id: number;
  category: number;
  number: number;
  subnumber: number;
  name: string;
}
